// Featured vehicles for the homepage carousel.
// Real values live in featuredVehicles.json, written directly by the
// backend when pressing "Guardar cambios en el proyecto" in /content-admin.
// Vehicle photos are resolved dynamically from src/assets/vehicles/ by
// filename (via webpack's require.context) so newly-uploaded vehicle
// images work without ever needing a new hand-written import statement.
import rawVehicles from "./featuredVehicles.json";

declare const require: {
  context: (path: string, deep: boolean, filter: RegExp) => {
    (key: string): string;
    keys: () => string[];
  };
};

export interface FeaturedVehicle {
  id: number;
  title: string;
  price: string;
  location: string;
  mileage?: string;
  image: string;
  badge?: string;
  url: string;
}

interface RawVehicle {
  id: number;
  title: string;
  price: string;
  location: string;
  mileage?: string;
  badge?: string;
  url: string;
  imageFileName?: string;
}

const vehicleImages = require.context("../assets/vehicles", false, /\.(jpe?g|png|webp)$/i);

function resolveVehicleImage(fileName?: string): string {
  if (!fileName) return "";
  try {
    return vehicleImages(`./${fileName}`);
  } catch {
    return "";
  }
}

export const featuredVehicles: FeaturedVehicle[] = (rawVehicles as RawVehicle[]).map((v) => ({
  id: v.id,
  title: v.title,
  price: v.price,
  location: v.location,
  mileage: v.mileage || "",
  image: resolveVehicleImage(v.imageFileName),
  badge: v.badge || "",
  url: v.url,
}));
